import { render, staticRenderFns } from "./CFormListItem.vue?vue&type=template&id=b5c85e54&scoped=true&"
import script from "./CFormListItem.vue?vue&type=script&lang=js&"
export * from "./CFormListItem.vue?vue&type=script&lang=js&"
import style0 from "./CFormListItem.vue?vue&type=style&index=0&id=b5c85e54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5c85e54",
  null
  
)

export default component.exports